import { c as _c } from "react/compiler-runtime";
import Spinner from '@/components/Spinner/Spinner';
const SideBarLayoutSpinner = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-[80vh] min-h-[50vh] w-full items-center justify-center px-8 py-6" data-testid="loading-placeholder"><Spinner size="large" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default SideBarLayoutSpinner;